import React from 'react';
import { HeroSection } from '../components/HeroSection';
import { TrustBar } from '../components/TrustBar';
import { TestimonialsTop } from '../components/TestimonialsTop';
import { ProblemSection } from '../components/ProblemSection';
import { StorySection } from '../components/StorySection';
import { VisualMethods } from '../components/VisualMethods';
import { WhatsIncluded } from '../components/WhatsIncluded';
import { ThirtyDayPlan } from '../components/ThirtyDayPlan';
import { BonusesSection } from '../components/BonusesSection';
import { DeliverySection } from '../components/DeliverySection';
import { IsThisForYou } from '../components/IsThisForYou';
import { PricingSection } from '../components/PricingSection';
import { AcceleratorKit } from '../components/AcceleratorKit';
import { TestimonialsBottom } from '../components/TestimonialsBottom';
import { GuaranteeSection } from '../components/GuaranteeSection';
import { FaqSection } from '../components/FaqSection';
import { CostOfInaction } from '../components/CostOfInaction';
import { FinalPricingCTA } from '../components/FinalPricingCTA';
import { EmotionalClose } from '../components/EmotionalClose';
import { Footer } from '../components/Footer';
import { StickyCTA } from '../components/StickyCTA';
import { SocialProofToast } from '../components/SocialProofToast';
export function Landing() {
  return <main className="min-h-screen bg-slate-50" data-id="element-340">
      <HeroSection data-id="element-341" />
      <TrustBar data-id="element-342" />
      <TestimonialsTop data-id="element-343" />
      <ProblemSection data-id="element-344" />
      <StorySection data-id="element-345" />
      <VisualMethods data-id="element-346" />
      <WhatsIncluded data-id="element-347" />
      <ThirtyDayPlan data-id="element-348" />
      <BonusesSection data-id="element-349" />
      <DeliverySection data-id="element-350" />
      <IsThisForYou data-id="element-351" />
      <PricingSection data-id="element-352" />
      <AcceleratorKit data-id="element-353" />
      <TestimonialsBottom data-id="element-354" />
      <GuaranteeSection data-id="element-355" />
      <FaqSection data-id="element-356" />
      <CostOfInaction data-id="element-357" />
      <FinalPricingCTA data-id="element-358" />
      <EmotionalClose data-id="element-359" />
      <Footer data-id="element-360" />
      <StickyCTA data-id="element-361" />
      <SocialProofToast data-id="element-362" />
    </main>;
}